import {AdcConjugationMethod} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Where a payload attaches on an antibody: a residue within one of the antibody's distinct domains. Mirrors
 * `ConjugationSite` in benchling/benchling_domain_graph/sdl/schemas/molbio/antibody_drug_conjugate.graphql.
 */
export interface ConjugationSite {
  /** Label of the antibody domain the residue is on. */
  domainLabel: string;
  /** Zero-based index of the residue within that domain. */
  residueIndex: number;
}

/** The row values that determine a row's candidate conjugation sites. */
export interface ConjugationSiteInputs {
  /** Id of the antibody selected in the row's Protein cell, or null if none is selected. */
  antibodyId: string | null;
  /** Method selected in the row's Conjugation method cell, or null if none (or an unknown value) is selected. */
  conjugationMethod: AdcConjugationMethod | null;
}

export const CONJUGATION_SITES_REQUIRE_PROTEIN_ERROR = 'Select a protein before choosing conjugation sites.';
export const CONJUGATION_SITES_REQUIRE_METHOD_ERROR =
  'Select a conjugation method before choosing conjugation sites.';
export const CONJUGATION_SITES_UNSUPPORTED_METHOD_ERROR =
  'Only engineered cysteine, disulfide, and lysine conjugation are supported so far.';
export const CONJUGATION_SITES_LOOKUP_ERROR = "Couldn't look up the protein's conjugation sites.";
export const CONJUGATION_SITES_MALFORMED_ERROR =
  'Conjugation sites could not be read. Select them again from the dropdown.';
